import {
  ICountry,
} from './authInterface';
import { RequestStatus } from 'mobx-store';

export enum QuestionType {
  RATING = 'RATING',
  TEXT   = 'TEXT',
  MCQ    = 'MCQ',
}

export interface Option {
  questionOptionId: number;
  text: string;
}

export interface QuestionOption {
  text: string;
  questionOptionId?: number;
  sharedQuestionsFormContentId?: number;
}

export interface QuestionStoreModel {
  title: string;
  type: QuestionType;
  isMandatory: boolean;
  questionId?: number; 
  questionOptions?: QuestionOption[];
  options?: QuestionOption[];
  shared?: boolean;
  sharedQuestionsFormContentId?: number;
}

export interface QuestionFormModel {
  title: string;
  type: QuestionType;
  isMandatory: boolean;
  options: Option[];
}

export interface FacilityFormStoreModel {
  questionsFormId?: number;
  title: string;
  availableCountries?: string[];
  questions: QuestionStoreModel[];
}

export interface FacilityFormFormModel {
  questionsFormId?: number;
  title: string;
  availableCountries?: string[];
  questions: QuestionFormModel[];
}

export interface IFacilityFormStore {

  facilityForms: Partial<FacilityFormStoreModel>[];
  selectedFacilityForm: any;
  loading: boolean;
  getFacilitiesFormsRequestStatus: RequestStatus;

  getAll(availableCountries: ICountry[], langCode?: string): Promise<void>;

  getOne(id: number, langCode?: string): Promise<void> ;

  create(newForm: FacilityFormStoreModel, langCode?: string): Promise<number>;

  update(updatedArea: FacilityFormStoreModel, facilityFormId: number, langCode?: string): Promise<void>;

}
